// Instrumentação do axios para o overlay global de carregamento.
// Fica aqui (e não em api/index.ts) porque o app tem dois módulos de API — o
// legado `api.ts` e o novo `api/index.ts` — e nem toda tela importa os dois.
// Como ambos usam a MESMA instância global do axios, registrar uma vez cobre
// todas as chamadas do sistema.
//
// Decisão por chamada (config do axios):
//   __loading ausente → regra padrão (acende, salvo endpoints silenciosos)
//   __loading: false  → nunca acende
//   __loading: true   → sempre acende, mesmo se o endpoint for silencioso
//   __loading: 'texto'→ acende com esse rótulo no lugar de "Carregando…"
import axios from 'axios'
import {inicioReq, fimReq, ehSilenciosa} from './loadingStore'

const MARCA = '__contouLoading'

const deveAcender = (config: any): boolean => {
  const escolha = config?.__loading
  if (escolha === false) return false
  if (escolha === true || typeof escolha === 'string') return true
  return !ehSilenciosa(config?.url)
}

axios.interceptors.request.use(
  (config) => {
    if (deveAcender(config)) {
      ;(config as any)[MARCA] = true
      const escolha = (config as any).__loading
      inicioReq(typeof escolha === 'string' ? escolha : undefined)
    }
    return config
  },
  (error) => Promise.reject(error)
)

const encerra = (config: any) => {
  if (config?.[MARCA]) {
    config[MARCA] = false // evita decrementar duas vezes
    fimReq(typeof config.__loading === 'string')
  }
}

axios.interceptors.response.use(
  (response) => {
    encerra(response.config)
    return response
  },
  (error) => {
    encerra(error?.config)
    return Promise.reject(error)
  }
)

export {}
